import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import { shadow } from '../styles-system/shadow.esm.js';
import { isElevationThemeKeys, elevations } from '../themes/theme-keys/elevations.esm.js';
import { isNumber } from '../utils/assertion.esm.js';
import { get } from '../utils/object.esm.js';
import toPx from '../utils/to-px.esm.js';

function elevationTransform (value, scale, props, variant) {
  var _value = isElevationThemeKeys(value) ? get(props.theme, "elevations.".concat(value), elevations[value]) : value;
  var styleVariant = get(props, variant, {
    boxShadow: variant
  });
  var boxShadow = props ? styleVariant && styleVariant.boxShadow ? get(props, "shadows.".concat(styleVariant.boxShadow)) : props.boxShadow ? get(scale, props.boxShadow) : props.__css ? get(scale, props.__css.boxShadow) : undefined : undefined;
  if (_typeof(boxShadow) === 'object' && boxShadow.variant) {
    boxShadow = get(scale, boxShadow.variant.replace('shadows.', ''));
  }
  if (typeof boxShadow === 'string') {
    var retVal = boxShadow.includes('rgba') ? boxShadow.slice(boxShadow.indexOf('rgba')) : boxShadow.includes('#') ? boxShadow.slice(boxShadow.indexOf('#')) : shadow;
    return isElevationThemeKeys(value) || isNumber(_value) ? "0px ".concat(toPx(_value) / 2, "px ").concat(toPx(_value), "px 0px ").concat(retVal) : boxShadow;
  }
  return;
}

export default elevationTransform;
//# sourceMappingURL=elevation-transform.esm.js.map
